import { useDispatcher } from '@jusbrasil-web/shared-utils-events'
import { useCallback, useContext } from 'react'

import { MetricsContext, MetricsProperties, sendCopyMetrics } from '../metrics'

function getUserId(metricsProperties: MetricsProperties, properties?: Record<string, unknown>) {
  return metricsProperties.user_id?.toString() || properties?.user_id?.toString() || null
}

export function useMetrics<T extends HTMLElement>() {
  const dispatcherReturn = useDispatcher<T>()
  const metricsProperties = useContext(MetricsContext)
  const sendCopyEvents = (
    extraMetricsProperties?: MetricsProperties,
    eventName = 'Doc.CopiedContent'
  ) => {
    const userPid = getUserId(metricsProperties, extraMetricsProperties)
    sendCopyMetrics({
      sendMetrics: dispatcherReturn.sendMetrics,
      userPid,
      eventName,
      metricsProperties: {
        ...metricsProperties,
        ...extraMetricsProperties,
      },
    })
  }
  const sendMetrics = useCallback(
    (name: string, properties?: Record<string, unknown>) => {
      const userId = getUserId(metricsProperties, properties)
      dispatcherReturn.sendMetrics(name, userId, {
        ...metricsProperties,
        ...properties,
        metadata: {
          ...((metricsProperties.metadata as object) ?? {}),
          ...((properties?.metadata as object) ?? {}),
        },
      })
    },
    [metricsProperties, dispatcherReturn]
  )

  return { ...dispatcherReturn, metricsProperties, sendCopyEvents, sendMetrics }
}
